import { cn } from '../utils/class-names.js'

export default function Wrapper ({ children, className }) {
  return (
    <div className={cn('w-full max-w-screen-md px-4 mx-auto', className)}>
      {children}
    </div>
  )
}
